import React, { useState } from 'react';
import axios from 'axios';
import second_image from '../../assets/home_img_2_small.png';
import third_image from '../../assets/home_img_3_small.png';
import ThankYouPopup from '../components/ThankYouPopup';
import '../../css/Home.css';

function Home() {
  const initFormData = {
    name: '',
    email: '',
    subject: 'default',
    message: ''
  };
  const [formData, setFormData] = useState(initFormData);
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handlerOnSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || formData.subject === 'default' || !formData.message) {
      setErrorMessage('Please fill out all fields.');
      return;
    }
    setErrorMessage('');
    axios.post('/api/contact_form', formData)
        .then(function () {
          setFormData(initFormData);
          setShowThankYouPopup(true);
          setTimeout(function () {
            setShowThankYouPopup(false);
          }, 2000);
        })
        .catch(function () {
          setErrorMessage('An error occurred. Please try again later.');
        });
  };

  return (
      <div className="home-container">
        <div className="home-first-container">
          <div className="home-first-wrap">
            <div className="home-first-title">
              Exclusive Network for Realtors and Service Companies
            </div>
            <div className="home-first-body">
              We connect realtors with vetted, premium service providers. Save time and build stronger networks, while gaining direct access to qualified real estate professionals.
            </div>
          </div>
        </div>
        <div className="home-second-container">
          <div className="home-second-wrap">
            <div className="home-second-image">
              <img src={second_image} alt="Mentium" />
            </div>
            <div className="home-second-title">
              All the Services You Need in One Place
            </div>
            <div className="home-second-body">
              Quickly find and book top-tier service companies in minutes. Streamline your hiring process and eliminate unwanted sales calls.
            </div>
            <div className={'home-second-button'}>
              <a href={'/agent'}>
                <div className="blue-button">CHECK IT OUT! &gt;&gt;</div>
              </a>
            </div>
          </div>
        </div>
        <div className="home-third-container">
          <div className="home-third-wrap">
            <div className="home-third-image">
              <img src={third_image} alt="Mentium" />
            </div>
            <div className="home-third-title">
              Realtors are looking for you!
            </div>
            <div className="home-third-body">
              Direct connections with local Realtors ready to hire - no intermediaries, no keyword games, just business.
            </div>
            <div className="home-third-button">
              <a href={'/service-company'}>
                <div className="blue-button">LIST MY BUSINESS &gt;&gt;</div>
              </a>
            </div>
          </div>
        </div>
        <div className="form-section-wrap">
          <div className="contact-wrap">
            <form onSubmit={handlerOnSubmit}>
              <div className="form-section-title">Contact Us</div>
              <div className="contact-form-item-wrap contact-multi-item-wrap">
                <div className="contact-item-col first">
                  <label className="form-control">
                    <div className="contact-form-label">
                      Name
                    </div>
                    <input
                        name="name"
                        placeholder="Your Name"
                        className="contact-form-input"
                        value={formData.name}
                        onChange={handleChange}
                    />
                  </label>
                </div>
                <div className="contact-item-col">
                  <label className="form-control">
                    <div className="contact-form-label">
                      Email
                    </div>
                    <input
                        name="email"
                        placeholder="Email Address"
                        className="contact-form-input"
                        value={formData.email}
                        onChange={handleChange}
                    />
                  </label>
                </div>
              </div>
              <div className="contact-form-item-wrap">
                <label className="form-control">
                  <div className="contact-form-label">
                    Subject
                  </div>
                  <select
                      name="subject"
                      className={`contact-form-input`}
                      value={formData.subject}
                      onChange={handleChange}
                  >
                    <option value="default" disabled>Select Your Subject</option>
                    <option value="agent">Agent</option>
                    <option value="serviceCompany">Service Company</option>
                    <option value="advertiser">Advertiser</option>
                    <option value="other">Other</option>
                  </select>
                </label>
              </div>
              <div className="contact-form-item-wrap">
                <label className="form-control">
                  <div className="contact-form-label">
                    Message
                  </div>
                  <textarea
                      name="message"
                      placeholder="Write your message.."
                      className="contact-form-input"
                      value={formData.message}
                      onChange={handleChange}
                  />
                </label>
              </div>
              <div className="contact-form-error">{errorMessage}</div>
              <div className="contact-form-submit-button">
                <button type="submit" className="blue-button">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
        {showThankYouPopup ? <ThankYouPopup message="Thanks for reaching out.  We will contact you within 24 hours." /> : null}
      </div>
  );
}

export default Home;
